
import SafeMotion from '@/components/motion/SafeMotion';
import MotionErrorBoundary from '@/components/motion/MotionErrorBoundary';
import ModernFeatureCard from "@/components/homepage/ModernFeatureCard";
import SectionHeader from "@/components/homepage/SectionHeader";
import { ShoppingBag, Users, BarChart3, Settings, Sparkles } from "lucide-react";

const features = [
  {
    icon: ShoppingBag,
    title: "Premium Products",
    description: "Curated collection of high-quality items",
    link: "/products",
    linkText: "Shop Now",
    gradient: "from-blue-500 to-blue-600",
    bgGradient: "from-blue-50 to-blue-100"
  },
  {
    icon: Users,
    title: "Customer Care",
    description: "24/7 support and personalized service",
    link: "/auth",
    linkText: "Get Started",
    gradient: "from-green-500 to-green-600",
    bgGradient: "from-green-50 to-green-100"
  },
  {
    icon: BarChart3,
    title: "Analytics",
    description: "Real-time insights and business intelligence",
    link: "/admin/analytics",
    linkText: "View Dashboard",
    gradient: "from-purple-500 to-purple-600",
    bgGradient: "from-purple-50 to-purple-100"
  },
  {
    icon: Settings,
    title: "Easy Management",
    description: "Intuitive tools for seamless operations",
    link: "/admin/settings",
    linkText: "Manage",
    gradient: "from-orange-500 to-orange-600",
    bgGradient: "from-orange-50 to-orange-100"
  }
];

const FeaturesSection = () => (
  <MotionErrorBoundary>
    <section className="py-12 sm:py-20 bg-gradient-to-br from-muted/20 via-transparent to-muted/30 relative">
      <div className="w-full px-4 md:px-8 lg:px-12 relative">
        <SectionHeader 
          markerIcon={<Sparkles className="h-4 w-4" />}
          title="Why Choose VRAM?"
          subtitle="Experience the perfect blend of quality, service, and innovation in modern e-commerce"
        />
        <SafeMotion
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ staggerChildren: 0.1, delayChildren: 0.2 }}
        >
          {features.map((feature, index) => (
            <ModernFeatureCard
              key={feature.title}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              link={feature.link}
              linkText={feature.linkText}
              gradient={feature.gradient}
              bgGradient={feature.bgGradient}
              index={index}
            />
          ))}
        </SafeMotion>
      </div>
    </section>
  </MotionErrorBoundary>
);

export default FeaturesSection;
